import { createAsyncThunk } from "@reduxjs/toolkit";
import { store } from "..";
import APICaller from "../../utils/APICaller";
import HandleSearch from "../../utils/CommonSearchComponent";

//typePrefix : string - Redux action type prefix
//endpoint : string - API endpoint (for APICaller)
//method : string - HTTP method
//withPagination : boolean - whether to normalize pagination
//useHandleSearch : boolean - use HandleSearch logic
//refreshList : boolean - dispatch list thunk after mutation
//listThunk : boolean - thunk to refresh after mutation
//transformResponse : null - optional transformer for API response

export const createDynamicThunk = ({
  typePrefix,
  endpoint = "",
  method = "POST",
  withPagination = false,
  useHandleSearch = false,
  refreshList = false,
  listThunk = null,
  transformResponse = null,
}) => {
  return createAsyncThunk(
    typePrefix,
    async (payload = {}, { getState, dispatch, rejectWithValue }) => {
      try {
        const { role, accessToken, lIUId, accessTokenExpiresOn } =
          getState().auth;

        // Case 1: use HandleSearch (list fetching)
        if (useHandleSearch) {
          const { route = "", filterValues = "", pagination = {} } = payload;

          const searchIn = route;
          const callActionFrom = route || "";

          const allStates =
            searchIn === process.env.REACT_APP_DASHBOARD_PR_SEARCH_IN ||
            searchIn === process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN
              ? payload?.allStates
              : {
                  pagination: pagination.current
                    ? pagination
                    : {
                        current: 1,
                        page: 1,
                        pageSize:
                          process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE,
                      },
                  ...(filterValues ? { filterValues } : {}),
                  //...(pagination ? {} : { fetchWithoutPagination: "yes" }),
                };

          await HandleSearch(
            role,
            accessToken,
            lIUId,
            accessTokenExpiresOn,
            searchIn,
            callActionFrom,
            allStates,
            ""
          );
          const decryptedData = store.getState().auth.list[searchIn + "_info"];

          const decryptedDataTotal =
            store.getState().auth.list[searchIn + "_total"];

          return {
            data: decryptedData || [],
            pagination: {
              ...allStates.pagination,
              total: decryptedDataTotal || 0,
            },
            totalCount: decryptedDataTotal || 0,
          };
        }

        // Case 2: regular REST API call
        let dataToSend;
        let dynamicEndpoint;
        if (payload instanceof FormData) {
          dataToSend = payload;
          dynamicEndpoint = endpoint;
        } else {
          const { route, id, ...restPayload } = payload;

          dataToSend = { ...restPayload, ...(route ? { route } : {}) };
          dynamicEndpoint = id ? `${endpoint}/${id}` : endpoint;
        }

        const response = await APICaller(
          role,
          accessToken,
          dynamicEndpoint,
          method,
          dataToSend,
          accessTokenExpiresOn
        );

        let result = response;

        if (withPagination) {
          result = {
            data: response?.data ?? [],
            pagination: response?.pagination ?? null,
            totalCount: response?.totalCount ?? null,
          };
        }

        if (transformResponse) {
          result = transformResponse(result);
        }

        // Case 3: mutation + refresh list
        if (refreshList && listThunk) {
          dispatch(listThunk({ route: payload.route || payload.action }));
        }

        return result;
      } catch (error) {
        return rejectWithValue(
          error.response?.data || { message: error.message }
        );
      }
    }
  );
};
